import { Body, Margin } from '@spritz-finance/ui'
import styled from 'styled-components'
import { isMobile } from '../../utils/userAgent'
import { useWalletDialog } from '../connectDialog/WalletConnectDialogProvider'
import { useConnectWallet } from '../connection/useConnectWallet'
import { getIsCoinbaseWallet, getIsInjected, getIsMetaMask } from '../connection/utils'
import { CoinbaseWalletOption, OpenCoinbaseWalletOption } from './CoinbaseWalletOption'
import {
    InjectedOption,
    InstallMetaMaskOption,
    MetaMaskOption,
    OpenMetamaskWalletOption,
} from './InjectedOption'
import { WalletConnectOption } from './WalletConnectOption'

const Grid = styled.div`
    display: grid;
    gap: ${Margin.Small};
`

export const WalletOptions: React.FC = () => {
    const { closeDialog } = useWalletDialog()
    const activate = useConnectWallet(closeDialog)

    const isInjected = getIsInjected()
    const isMetaMask = getIsMetaMask()
    const isCoinbaseWallet = getIsCoinbaseWallet()

    const isCoinbaseWalletBrowser = isMobile && isCoinbaseWallet
    const isMetaMaskBrowser = isMobile && isMetaMask
    const isInjectedMobileBrowser = isCoinbaseWalletBrowser || isMetaMaskBrowser

    let injectedOption
    if (!isInjected) {
        if (!isMobile) {
            injectedOption = <InstallMetaMaskOption />
        } else {
            injectedOption = <OpenMetamaskWalletOption />
        }
    } else if (!isCoinbaseWallet) {
        if (isMetaMask) {
            injectedOption = <MetaMaskOption tryActivation={activate} />
        } else {
            injectedOption = <InjectedOption tryActivation={activate} />
        }
    }

    let coinbaseWalletOption
    if (isMobile && !isInjectedMobileBrowser) {
        coinbaseWalletOption = <OpenCoinbaseWalletOption />
    } else if (!isMobile || isCoinbaseWalletBrowser) {
        coinbaseWalletOption = <CoinbaseWalletOption tryActivation={activate} />
    }

    const walletConnectionOption =
        (!isInjectedMobileBrowser && <WalletConnectOption tryActivation={activate} />) ?? null

    return (
        <Grid>
            {injectedOption}
            {coinbaseWalletOption}
            {walletConnectionOption && (
                <>
                    <Body.SmBold size={16}>Other ways to connect your wallet:</Body.SmBold>
                    {walletConnectionOption}
                </>
            )}
        </Grid>
    )
}
